import { simple } from 'src/utils/reducers';
import * as getNotifications from './reducers/get';
import removeNotification from './reducers/remove';

// eslint-disable-next-line import/no-default-export
export default simple({
    NOTIFICATIONS_REMOVE: removeNotification,

    NOTIFICATIONS_GET_REQUEST: getNotifications.request,
    NOTIFICATIONS_GET_ERROR: getNotifications.error,
    NOTIFICATIONS_GET_FINISH: getNotifications.finish,
});
